<template>
  <section class="landing_container">
    <div class="left">
      <h1 class="marnope ">
        Be part of the largest
        <br />
        qualified talent pool
      </h1>
      <p style="margin-bottom: 50px" class="manrope regular">
        Upskill is a skill sharing platform that matches <br />
        talents to companies.
        <br />
        Be part of our qualified talent pool and get hired
      </p>
      <!-- <form>
        <input type="text" name="s" placeholder="Search" />
        <button>Search</button>
      </form> -->
      <div class="home-hero__content-cta-1">
        <a href="#jobseeker" class="btn btn-primary hover text-white"
          >Job Seekers</a
        >

        <a
          href="http://upskillwork.com/"
          class="btn btn-primary hover text-white"
          >Recruiters</a
        >

        <router-link to="/host_workshop">
          <a class="btn btn-primary hover text-white">Trainer</a>
        </router-link>
      </div>
    </div>
    <div class="home_hero">
      <img src="../../assets/homeV2/top-banner-2.png" alt="" />
    </div>

    <div class="home-hero__content-cta-2 mb-only">
      <a href="#jobseeker" class="btn btn-primary hover text-white"
        >Job Seekers</a
      >

      <router-link to="/recruit">
        <a class="btn btn-primary hover text-white">Recruiters</a>
      </router-link>

      <router-link to="/host_workshop">
        <a class="btn btn-primary hover text-white">Trainer</a>
      </router-link>
    </div>
  </section>
</template>

<script>
export default {
  created() {
    this.Loaded()
  },
}
</script>

<style scoped>
.home-hero__content-cta-1 {
  padding-top: 30px;
  display: flex;
}
.home-hero__content-cta-2 {
  display: none;
}
.home-hero__content-cta-1 a {
  font-family: 'Manrope', sans-serif;
  font-size: 18px;
  letter-spacing: 0;
  line-height: 27px;
  text-transform: capitalize;
  font-weight: 700;

  width: 240px;
  height: 65px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
}
.left {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  padding-left: 20px;
}
.left h1 {
  font: 800 4.2rem/1.4rem 'Manrope';
  line-height: 5rem;
  letter-spacing: -4px;
}
.left p {
  padding-top: 20px;
  padding-left: 0px;

  color: #626367;
  font-size: 24px;
}
.landing_container {
  display: grid;
  max-width: 1300px;
  grid-template-columns: 1.5fr 1fr;

  margin: 0 auto;
  padding-bottom: 100px;
}
.home-hero__content p {
  max-width: 550px;
}
@media (max-width: 767.98px) {
  .home-hero__content-cta-2 a {
    font-family: 'Manrope', sans-serif;
    font-size: 18px;
    letter-spacing: 0;
    line-height: 27px;
    text-transform: capitalize;
    font-weight: 700;

    min-width: 90%;
    height: 50px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin: 10px 0;
  }
  .mb-only {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }
  .home_hero img {
    max-width: 300px;
  }
  .home-hero__content-cta-1 {
    display: none;
    /* display: flex;
    flex-direction: column;
    align-items: center; */
  }
  .left {
    padding-left: 0;
  }
  .left h1 {
    font: 700 2.5rem/1rem 'Manrope';
    line-height: 3rem;
    letter-spacing: -1px;
    text-align: center;
    padding: 0 25px;
  }
  .left p {
    text-align: center;
    padding: 0 25px;
  }
  .landing_container {
    display: grid;
    max-width: 100%;
    grid-template-columns: 1fr;
    place-items: center;

    margin: 0 auto;
    padding-bottom: 60px;
  }
}
</style>
